import React, { Component } from "react";
import {Link} from "react-router-dom";
import Select from "react-select";
import { CgSearch } from 'react-icons/cg';

import './Customers.scss';
import MyContext from '../MyContext.jsx';


class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers : [],
      showing_customers :[],
     
    }
    this.formChange = this.formChange.bind(this);
  }

  componentDidMount(){  
    var obj_this = this;
    obj_this.getAllSchedules();
  }
  

  getAllSchedules(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/getAllCustomers`;
    obj_this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : obj_this.context.user_details.sid,
      },
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        var customers = return_data.customers.filter((item) =>item.customer_name != null);
        customers.sort((a, b) => a.customer_name.localeCompare(b.customer_name));        
       
        obj_this.setState({
          customers: customers,
          showing_customers : customers,
        
        });
        
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      obj_this.context.loading(0);
      alert("Network error");
    });

  }


  formChange(e){
    // console.log(e.target.value);
    var showing_customers =[];
  
    if(e.target.value){
      showing_customers = this.state.customers.filter((item) => {return item.customer_name.toLowerCase().includes(e.target.value.toLowerCase())});
    
    }
    else{
      showing_customers = this.state.customers;
   
    }
    // showing_customers = showing_customers.length?showing_customers:this.state.customers;
    this.setState({
      showing_customers : showing_customers,
     
    });
  }

  render(){
  return (
    <MyContext.Consumer>
      {context => (
        <div className="customers_page_container noselect">
          <div className="header_spacer"></div>
          <div className="schedules_container uijs swipemenu">
            <div className="page_header">
              <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Customers</div>
              <Link className="new_schedule_button" to="/customers/new"> 
                <i className="fa fa-plus"></i> New</Link>
            </div>
           
            <div>
             
              <div className="search_container">
                    <CgSearch/>
                    <input className="customer_search_input" 
                      placeholder="Search customer.."
                      onChange={this.formChange}
                    />
              </div>
            </div>
            {/* <span>
            Executive Coordinates : {this.state.my_coordinates.latitude?<span>Lat {this.state.my_coordinates.latitude} - Lon {this.state.my_coordinates.longitude}</span> :"Null"}
            </span> */}
            <div className="list_blocks_container">
              <div className="lists_container">
                
                {this.state.showing_customers.map((item,idx)=>(
                  <div className="single_schedule_container" key={idx}>
                    <div className="scheduled_customer_name_delete_button_container">
                      <div className="customer_card_split_container">
                        <div className="customer_details_left_col">
                          <div className="scheduled_customer_name">
                            <div className="customer_name_title">
                              <i className="fa fa-user"></i>
                              <span>{item.customer_name}</span>
                            </div>
                            <div className="last_visit_info">
                              <i className="fa fa-clock"></i>
                              <span>{item.last_visit ? `Last Visited: ${new Date(item.last_visit).toLocaleDateString('en-GB')}` : 'Not Visited'}</span>
                            </div>
                          </div>
                          <div className="schedules_leftside_container">
                            <div className="scheduled_address" style={{display:item.address?"block":"none"}}> 
                              <i className="fas fa-map"></i><span> {item.address}</span> 
                            </div>
                            <div className="scheduled_location_name" style={{display:item.location_name?"block":"none"}}> 
                              <i className="fas fa-map-marker-alt"></i><span>{item.location_name}</span> 
                            </div>
                            <div className="scheduled_location_name" style={{display:item.distributor_category?"block":"none"}}> 
                              <i className="fa fa-list-alt"></i><span>{item.distributor_category}</span> 
                            </div>
                          </div>
                        </div>
                        <div className="customer_actions_right_col">
                          <div className="schedules_button_container">
                            <div className="identifying_icons">
                              <div style={{visibility:item.contact_no?"visible":"hidden"}}>
                                <a className="contact_no" href={"tel:"+item.contact_no??''}>
                                  <i className="fas fa-phone-alt" aria-hidden="true"></i>
                                </a>
                              </div>
                              <div style={{visibility:item.latitude?"visible":"hidden"}}>
                                <a className="map_button" href={"geo:0,0?q="+item.latitude+","+item.longitude+"('"+item.customer_name+"')"}>
                                  <i className="fas fa-map-marker-alt"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                ))}
              </div>
            
             

            </div>

          </div>
          {/** bottom spacer removed; global app_content adds bottom padding **/}

        </div>
      )}
    </MyContext.Consumer>
  )}
}

export default Customers;
Customers.contextType = MyContext;
